import React from "react";
import HeaderPresenter from "./HeaderPresenter";

const HeaderContainer = () => {
  return <HeaderPresenter />;
};

export default HeaderContainer;
